import { useEffect } from 'react';
import { COMPANY_CONFIG } from '../config/config';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical,
  ogImage = '/images/Logo.png',
  ogType = 'website'
}) => {
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }

    // Update or create meta tags
    const updateMetaTag = (name, content, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Update or create link tags
    const updateLinkTag = (rel, href) => {
      let element = document.querySelector(`link[rel="${rel}"]`);
      if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
      }
      element.setAttribute('href', href);
    };

    // Basic meta tags
    if (description) {
      updateMetaTag('description', description);
    }

    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Open Graph tags
    updateMetaTag('og:title', title || `${COMPANY_CONFIG.appname} - ${COMPANY_CONFIG.tagline}`, 'property');
    updateMetaTag('og:description', description || `Book your bus tickets online with ${COMPANY_CONFIG.appname}. Safe, reliable, and comfortable bus services across Sri Lanka.`, 'property');
    updateMetaTag('og:type', ogType, 'property');
    updateMetaTag('og:image', `${window.location.origin}${ogImage}`, 'property');
    updateMetaTag('og:url', canonical || window.location.href, 'property');
    updateMetaTag('og:site_name', COMPANY_CONFIG.appname, 'property');
    updateMetaTag('og:locale', 'en_US', 'property');

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title || `${COMPANY_CONFIG.appname} - ${COMPANY_CONFIG.tagline}`);
    updateMetaTag('twitter:description', description || `Book your bus tickets online with ${COMPANY_CONFIG.appname}.`);
    updateMetaTag('twitter:image', `${window.location.origin}${ogImage}`);

    // Canonical URL
    if (canonical) {
      updateLinkTag('canonical', canonical);
    }

    // Additional SEO tags
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('author', COMPANY_CONFIG.appname);
    updateMetaTag('geo.region', 'LK');
    updateMetaTag('geo.placename', 'Sri Lanka');

    // Mobile optimization
    updateMetaTag('mobile-web-app-capable', 'yes');
    updateMetaTag('apple-mobile-web-app-capable', 'yes');
    updateMetaTag('apple-mobile-web-app-status-bar-style', 'default');
    updateMetaTag('apple-mobile-web-app-title', COMPANY_CONFIG.appname);

  }, [title, description, keywords, canonical, ogImage, ogType]);

  return null;
};

export default SEO;
